import Swiper from "swiper/bundle";

export default class SwiperHelper {

  initBase(el) {
    let moduleConfig = {};

    if (el.hasAttribute('data-breakpoints-config') && el.getAttribute('data-breakpoints-config') !== '') {
      moduleConfig = JSON.parse(el.getAttribute('data-breakpoints-config'));
    }

    let config = {
      speed: 600,
      slidesPerView: 'auto',
      loop: !!el.hasAttribute('hero-carousel'),
      autoplay: el.hasAttribute('js-carousel-autoplay')
        ? {
          delay: 4000,
        }
        : false,
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: moduleConfig?.IsShowNavBtn ? el.parentNode.querySelector('[js-carousel-nav-next]') : el.querySelector('[js-carousel-trigger-next]'),
        prevEl: moduleConfig?.IsShowNavBtn ? el.parentNode.querySelector('[js-carousel-nav-prev]') : el.querySelector('[js-carousel-trigger-prev]'),
      },
      pagination: {
        el: el.querySelector('[js-carousel-pagination]'),
        type: el.hasAttribute('js-carousel-fraction-pagination') ? 'fraction' : 'bullets',
        dynamicBullets: true,
        clickable: true,
      },
    };

    config = { ...config, ...moduleConfig };

    return new Swiper(el, config);
  }

  initGallery(el) {
    let config = {
      speed: 600,
      slidesPerView: 1,
      loop: !!el.hasAttribute('hero-carousel'),
      autoplay: el.hasAttribute('js-carousel-autoplay')
        ? {
          delay: 4000,
        }
        : false,
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: el.querySelector('[js-carousel-trigger-next]'),
        prevEl: el.querySelector('[js-carousel-trigger-prev]'),
      },
      pagination: {
        el: el.querySelector('[js-carousel-pagination]'),
        type: el.hasAttribute('js-carousel-fraction-pagination') ? 'fraction' : 'bullets',
        dynamicBullets: true,
        clickable: true,
      },
    };

    if (
      el.hasAttribute('data-breakpoints-config') &&
      el.getAttribute('data-breakpoints-config') !== ''
    ) {
      config = { ...config, ...JSON.parse(el.getAttribute('data-breakpoints-config')) };
    }

    return new Swiper(el, config);
  }


}
